import React, { Component } from 'react';

import { DeckAPI, LayoutGap } from '@philips-emr/tws-components-api';
import { Expression } from '@philips-emr/tws-constants';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { array, arrayOf, bool, element, eventListener, expression, number, oneOf, oneOfType, string } from '@philips-emr/tws-core/lib/component/prop-types';
import { msg } from '@philips-emr/tws-core/lib/services/message-service';
import { enumValues, isFunction } from '@philips-emr/tws-utils';

import { Button, CardList } from '..';

import './deck.scss';

@AwesomeComponent({ type: ComponentType.LIST, api: DeckAPI })
class Deck extends Component {
  static propTypes = {
    children: oneOfType([element, arrayOf(element)]).notEnumerable(),
    columnGap: oneOf(enumValues(LayoutGap)).group('layout'),
    data: array.notEnumerable(),
    done: bool.notEnumerable(),
    emptyResultSubtitleExpression: expression,
    emptyResultTitleExpression: expression,
    limit: number,
    loadMoreExpression: expression,
    loading: bool.notEnumerable(),
    onClick: eventListener,
    onContextMenuClick: eventListener,
    onDoubleClick: eventListener,
    onNextPage: eventListener,
    onPrevPage: eventListener,
    page: number.notEnumerable(),
    reset: bool.notEnumerable(),
    rowGap: oneOf(enumValues(LayoutGap)).group('layout'),
    uuid: string,
  };

  static defaultProps = {
    columnGap: LayoutGap.LARGE,
    done: true,
    limit: 12,
    loadMoreExpression: Expression.LOAD_MORE,
    page: 0,
    rowGap: LayoutGap.LARGE,
  };

  onLoadMoreClick = () => {
    const { limit, onNextPage, page } = this.props;

    isFunction(onNextPage) &&
      onNextPage({ limit, page: page + 1, accumulate: true });
  };

  onItemClick = (item) => {
    const { onClick } = this.props;

    isFunction(onClick) && onClick({ value: item });
  };

  onDoubleClick = (event) => {
    const { onDoubleClick } = this.props;

    isFunction(onDoubleClick) && onDoubleClick(event);
  };

  onContextMenuClick = (event) => {
    const { onContextMenuClick } = this.props;

    isFunction(onContextMenuClick) && onContextMenuClick(event);
  };

  fetchFirstPage() {
    const { limit, onNextPage } = this.props;

    isFunction(onNextPage) && onNextPage({ limit, page: 0, accumulate: false });
  }

  componentDidMount() {
    this.fetchFirstPage();
  }

  componentDidUpdate({ reset: prevReset }) {
    const { reset } = this.props;

    if (reset && prevReset !== reset) {
      this.fetchFirstPage();
    }
  }

  renderCards() {
    const { children, columnGap, data, emptyResultSubtitleExpression, emptyResultTitleExpression, loading, rowGap, uuid } = this.props;

    return (
      <CardList
        columnGap={columnGap}
        data={data}
        emptyResultSubtitleExpression={emptyResultSubtitleExpression}
        emptyResultTitleExpression={emptyResultTitleExpression}
        loading={loading}
        onClick={this.onItemClick}
        onContextMenuClick={this.onContextMenuClick}
        onDoubleClick={this.onDoubleClick}
        rowGap={rowGap}
        showAddNew={false}
        uuid={uuid}
      >
        {children}
      </CardList>
    );
  }

  renderLoadMore() {
    const { done, loadMoreExpression, loading } = this.props;

    if (loading || done) {
      return null;
    }

    return (
      <Button className="c-deck__load-more"
        onClick={this.onLoadMoreClick}
        onDoubleClick={this.onDoubleClick}
        onContextMenuClick={this.onContextMenuClick}
        theme="secondary">
        {msg(loadMoreExpression)}
      </Button>
    );
  }

  render() {
    return (
      <div className="c-deck">
        {this.renderCards()}
        {this.renderLoadMore()}
      </div>
    );
  }
}

export default Deck;
